import(/* webpackMode: "eager" */ "/vercel/path0/src/app/upload/amazon/page.tsx");
